/**
 * @file   src\components\Introduction\IntroductionDetail.js
 * @brief  This file is responsible for the view of accepted introductions list data.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
import _ from "lodash";
import {
  getpropertyName,
  removeDecimalZeros,
  thousandSeperatedValue,
} from "../../helpers/common";
import { IS_LAND } from "../../constants/common";
import { introLotSize } from "../../helpers/introProperty";
import {
  introductionPhotoAlt,
  introductionPhotoSrc,
  showPlaceholderOnError,
} from "../../helpers/introductionPhoto";

const IntroductionDetail = (props) => {
  const { introDetails } = props;

  // Initialize variables.
  const bedRoom = removeDecimalZeros(_.get(introDetails, "Bedrooms", ""));
  const bathRoom = removeDecimalZeros(_.get(introDetails, "Bathrooms", ""));
  const sqFt = removeDecimalZeros(_.get(introDetails, "Sqft", ""));
  const lotSize = introLotSize(introDetails, {
    isLand: _.get(introDetails, "PropertyTypeId", "") === IS_LAND,
  });
  const askingPrice = _.get(introDetails, "AskingPrice", "");
  const inventoryImage = introductionPhotoSrc(introDetails);
  const location = [
    _.get(introDetails, "City", ""),
    _.get(introDetails, "State", ""),
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <>
      <figure className="flex-shrink-0">
        <img
          src={inventoryImage}
          alt={introductionPhotoAlt(getpropertyName(introDetails), location)}
          onError={showPlaceholderOnError}
        />
      </figure>
      <div className="detail">
        <h5>
          {" "}
          {getpropertyName(introDetails)} in {_.get(introDetails, "City", "")},{" "}
          {_.get(introDetails, "State", "")}
        </h5>
        <ul className="wantad-btm-list mt-2">
          {bedRoom ? <li> {bedRoom} Beds</li> : <></>}

          {bathRoom ? <li>{bathRoom} Baths </li> : <></>}
          {sqFt ? <li> {sqFt} sqft</li> : <></>}

          {lotSize ? <li>{lotSize}</li> : <></>}
        </ul>
        <p> ${askingPrice && thousandSeperatedValue(askingPrice)}</p>
      </div>
    </>
  );
};
export default IntroductionDetail;
